<template>
    <div class="profession-track-wrapper">
        <component
            v-for="(item, index) in grids"
            :key="index"
            :class="item.class"
            :is="item.name"
        >
            <template
                slot="Profession"
            >
                <Profession
                    v-loading="isLoadProfessions"
                />
            </template>

            <template
                slot="Timeline"
            >
                <Timeline
                    class="timeline-desktop"
                    v-loading="isLoadPrograms"
                    :selected-program-id="selectedProgramId"
                    @select="setSelected"
                ></Timeline>
                <TimelineMobile
                    class="timeline-mobile"
                    v-loading="isLoadPrograms"
                    @select="setSelected"
                >
                </TimelineMobile>
            </template>

            <template
                slot="Bucket"
            >
                <Program
                    v-loading="isLoadPrograms"
                    v-if="selectedProgramId"
                    :program="getProgramById(selectedProgramId)"
                    :module="getModuleById(selectedProgramId, selectedModuleId)"
                    @close="selectedProgramId = null"
                ></Program>
                <Bucket v-loading="isLoadPrograms" v-else></Bucket>
            </template>

            <template
                slot="Competences"
            >
                <Competences
                    class="competence-desktop"
                    v-loading="isLoadCompetences"
                ></Competences>
                <CompetencesMobile
                    class="competence-mobile"
                    v-loading="isLoadCompetences"
                />
            </template>
        </component>
        <transition name="fade">
            <div
                class="program-popup-wrapper"
                v-if="isShownProgramCardInPopup"
                @click.stop="clearSelected"
            >
                <div
                    class="program-popup-content"
                    @click.stop
                >
                    <Program
                        :program="getProgramById(selectedProgramId)"
                        :module="getModuleById(selectedProgramId, selectedModuleId)"
                        @close="clearSelected"
                    />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Timeline from '../components/account/track/timeline/Timeline';
import TimelineMobile from '../components/account/track/timeline/TimelineMobile';
import Bucket from '../components/account/track/bucket/Bucket';
import Competences from '../components/account/track/competences/Competences';
import CompetencesMobile from '../components/account/track/competences/CompetencesMobile';
import Profession from '../components/account/track/profession/Profession';
import Program from '../components/account/track/program/Program';

import LGGrid from '../components/account/track/components/LGGrid';
import MDGrid from '../components/account/track/components/MDGrid';
import SMGrid from '../components/account/track/components/SMGrid';
import XSGrid from '../components/account/track/components/XSGrid';

const actions = [
    'loadTrack',
    'loadCompetences',
    'loadPrograms',
    'loadProfessions',
    'loadTrackPage',
];

const getters = [
    'getTrack',
    'getProgramById',
    'getModuleById',
    'getHasGoals',
];

export default {
    name: 'AccountTrackTimeline',
    data: () => ({
        grids: [
            {
                name: 'LGGrid',
                class: 'xl-grid',
            },
            {
                name: 'LGGrid',
                class: 'lg-grid',
            },
            {
                name: 'MDGrid',
                class: 'md-grid',
            },
            {
                name: 'SMGrid',
                class: 'sm-grid',
            },
            {
                name: 'XSGrid',
                class: 'xs-grid',
            },
        ],
        selectedProgramId: null,
        selectedModuleId: null,

        isLoadCompetences: false,
        isLoadPrograms: false,
        isLoadProfessions: false,
    }),
    components: {
        Profession,
        Timeline,
        TimelineMobile,
        Bucket,
        Competences,
        CompetencesMobile,
        Program,
        LGGrid,
        MDGrid,
        SMGrid,
        XSGrid,
    },
    computed: {
        ...mapGetters('accountTrack', getters),
        ...mapGetters({
            screenWidth: 'width',
        }),
        isShownProgramCardInPopup() {
            return this.selectedProgramId !== null && this.screenWidth <= 1281;
        },
    },
    methods: {
        ...mapActions('accountTrack', actions),
        setTab(index){
            this.activeTab = index;
        },
        setSelected(event) {
            this.selectedProgramId = event.programId;
            this.selectedModuleId = event.moduleId;
        },
        clearSelected() {
            this.selectedProgramId = null;
            this.selectedModuleId = null;
        },

        async loadTrackHandler() {
            this.isLoadProfessions = true;
            this.isLoadCompetences = true;
            this.isLoadPrograms = true;
            await this.loadTrack();
        },
        async loadProfessionsHandler(trackId) {
            await this.loadProfessions({ trackId });
            this.isLoadProfessions = false;
        },
        async loadCompetencesHandler(trackId) {
            await this.loadCompetences(trackId);
            this.isLoadCompetences = false;
        },
        async loadProgramsHandler(trackId) {
            await this.loadPrograms(trackId);
            this.isLoadPrograms= false;
        },
    },
    async mounted() {
        this.loadTrackPage();
        await this.loadTrackHandler();
        await Promise.all([
            this.loadCompetencesHandler(this.getTrack.id),
            this.loadProgramsHandler(this.getTrack.id),
            this.loadProfessionsHandler(this.getTrack.id),
        ]);
        if (!this.getHasGoals) {
            this.$router.push({ name: 'account-main' });
        }
    },
};
</script>

<style lang="scss" scoped>
    @import '~@/styles/rem';

    .profession-track-wrapper{
        width: 100%;
        font-family: 'Proxima Nova', sans-serif;

        /*<!--.mobile-grid{-->*/
        /*<!--    display: none;-->*/
        /*<!--    @include on-tablet{-->*/
        /*<!--        display: block;-->*/
        /*<!--    }-->*/
        /*<!--    -->*/
        /*<!--    .tabs{-->*/
        /*<!--        width: 100%;-->*/
        /*<!--        min-height: 80vh;-->*/
        /*<!--        padding: 32px;-->*/
        /*<!--    }-->*/
        /*<!--}-->*/

        .timeline-desktop {
            display: block;
        }
        .timeline-mobile {
            display: none;
        }

        .competence-desktop {
            display: block;
        }
        .competence-mobile {
            display: none;
        }

        @include on-xl {
            .lg-grid {
                display: none;
            }
            .xl-grid {
                display: block;
            }
            .xs-grid {
                display: none;
            }
            .sm-grid {
                display: none;
            }
            .md-grid {
                display: none;
            }
        }

        @include on-lg {
            .lg-grid {
                display: block;
            }
            .xl-grid {
                display: none;
            }
            .xs-grid {
                display: none;
            }
            .sm-grid {
                display: none;
            }
            .md-grid {
                display: none;
            }
        }

        @include on-md {
            .lg-grid {
                display: none;
            }
            .xl-grid {
                display: none;
            }
            .xs-grid {
                display: none;
            }
            .sm-grid {
                display: none;
            }
            .md-grid {
                display: block;
            }
        }

        @include on-sm {
            .lg-grid {
                display: none;
            }
            .xl-grid {
                display: none;
            }
            .xs-grid {
                display: none;
            }
            .sm-grid {
                display: block;
            }
            .md-grid {
                display: none;
            }
            .competence-desktop {
                display: none;
            }
            .competence-mobile {
                display: block;
            }
            .timeline-desktop {
                display: none;
            }
            .timeline-mobile {
                display: block;
            }
        }

        @include on-xs {
            .lg-grid {
                display: none;
            }
            .xl-grid {
                display: none;
            }
            .xs-grid {
                display: block;
            }
            .sm-grid {
                display: none;
            }
            .md-grid {
                display: none;
            }
        }
    }

    .program-popup {
        &-wrapper {
            position: fixed;
            z-index: 10000;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgba(42, 38, 38, 0.5);
            align-items: center;
            justify-content: center;

            @include on-md {
                padding: 32px;
            }
            @include on-sm {
                padding: 16px;
            }

            max-height: 100vh;
            overflow: scroll;
        }

        &-content {
            width: 100%;
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: min-height .25s ease-in-out,
                    max-height .25s ease-in-out;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
